import React, { forwardRef } from 'react';
import { styled } from '@linaria/react';

import SelectDownArrow from './assets/arrow--down.inline.svg';
import ArrowRightIcon from './assets/arrow--right.inline.svg';
import CalendarIcon from './assets/calendar.inline.svg';
import SuccessCheckmarkIcon from './assets/check-mark--green.inline.svg';
import ChevronIcon from './assets/chevron.inline.svg';
import CloseIcon from './assets/close.inline.svg';
import DisclaimerBubbleIcon from './assets/disclaimer-bubble.inline.svg';
import HideIcon from './assets/hide.inline.svg';
import DescriptorBadIcon from './assets/icon_descriptor--bad.inline.svg';
import DescriptorGoodIcon from './assets/icon_descriptor--good.inline.svg';
import InfoIcon from './assets/info.inline.svg';
import LockIcon from './assets/lock.inline.svg';
import LogoutIcon from './assets/logout.inline.svg';
import MailIcon from './assets/mail.inline.svg';
import MinusIcon from './assets/minus.inline.svg';
import MyordersIcon from './assets/myorders.inline.svg';
import NeworderIcon from './assets/neworder.inline.svg';
import NextIcon from './assets/next.inline.svg';
import NotificationBellIcon from './assets/notification-bell.inline.svg';
import OrderFeatherIcon from './assets/orders-feather.inline.svg';
import PlusIcon from './assets/plus.inline.svg';
import PrevIcon from './assets/prev.inline.svg';
import ShowIcon from './assets/show.inline.svg';
/**
 * @see https://samherbert.net/svg-loaders/
 */
import SpinnerAnimation from './assets/spinner.inline.svg';
import StarIcon from './assets/star.inline.svg';
import UserIcon from './assets/user.inline.svg';

const StrokeSvg = styled.span`
  & svg {
    outline: none;
    display: block;
    stroke: var(--bb-icon-color);
  }

  &:focus svg,
  &:hover svg {
    stroke: var(--bb-icon-color--hover);
  }
`;

const StrokePath = styled.span`
  & svg {
    outline: none;
    display: block;
  }

  & path {
    stroke: var(--bb-icon-color);
  }

  &:focus path,
  &:hover path {
    stroke: var(--bb-icon-color--hover);
  }
`;

const FillSvg = styled.span`
  & svg {
    outline: none;
    display: block;
    fill: var(--bb-icon-color);
  }

  &:focus svg,
  &:hover svg {
    fill: var(--bb-icon-color--hover);
  }
`;

const FillPath = styled.div`
  & svg {
    outline: none;
    display: block;
  }

  & path {
    fill: var(--bb-icon-color);
  }

  &:focus path,
  &:hover path {
    fill: var(--bb-icon-color--hover);
  }
`;

export const Calendar = props => (
  <StrokePath>
    <CalendarIcon
      {...props}
      tabIndex="-1"
    />
  </StrokePath>
);
export const Chevron = props => (
  <StrokePath>
    <ChevronIcon
      {...props}
      tabIndex="-1"
    />
  </StrokePath>
);
export const Close = props => (
  <FillPath>
    <CloseIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
);
export const Hide = props => (
  <StrokeSvg>
    <HideIcon
      {...props}
      tabIndex="-1"
    />
  </StrokeSvg>
);
export const Show = props => (
  <StrokeSvg>
    <ShowIcon
      {...props}
      tabIndex="-1"
    />
  </StrokeSvg>
);
export const Info = forwardRef((props, ref) => (
  <FillPath ref={ref}>
    <InfoIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
));
export const Minus = props => (
  <StrokePath>
    <MinusIcon
      {...props}
      tabIndex="-1"
    />
  </StrokePath>
);
export const Plus = props => (
  <StrokePath>
    <PlusIcon
      {...props}
      tabIndex="-1"
    />
  </StrokePath>
);
export const Star = props => (
  <StarIcon
    {...props}
    tabIndex="-1"
  />
);
export const Logout = props => (
  <FillPath>
    <LogoutIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
);
export const User = props => (
  <FillPath>
    <UserIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
);
export const Neworder = props => (
  <FillPath>
    <NeworderIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
);
export const Myorders = props => (
  <FillPath>
    <MyordersIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
);
export const Prev = props => (
  <StrokePath>
    <PrevIcon
      {...props}
      tabIndex="-1"
    />
  </StrokePath>
);
export const Next = props => (
  <StrokePath>
    <NextIcon
      {...props}
      tabIndex="-1"
    />
  </StrokePath>
);
export const ArrowRight = props => (
  <ArrowRightIcon
    {...props}
    tabIndex="-1"
  />
);
export const ArrowDown = props => (
  <FillPath>
    <SelectDownArrow
      {...props}
      tabIndex="-1"
    />{' '}
  </FillPath>
);
export const Mail = props => (
  <FillPath>
    <MailIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
);
export const Lock = props => (
  <StrokePath>
    <LockIcon
      {...props}
      className="lockIcon"
      tabIndex="-1"
    />
  </StrokePath>
);
export const OrderFeather = props => (
  <FillPath>
    <OrderFeatherIcon
      {...props}
      tabIndex="-1"
    />
  </FillPath>
);
export const SuccessCheckmark = props => (
  <SuccessCheckmarkIcon
    {...props}
    tabIndex="-1"
  />
);
export const DisclaimerBubble = props => (
  <DisclaimerBubbleIcon
    {...props}
    tabIndex="-1"
  />
);

export const NotificartionBell = props => (
  <NotificationBellIcon
    {...props}
    tabIndex="-1"
  />
);

export const Spinner = props => (
  <FillSvg>
    <SpinnerAnimation
      {...props}
      tabIndex="-1"
    />
  </FillSvg>
);
export const DescriptorGood = props => (
  <DescriptorGoodIcon
    {...props}
    tabIndex="-1"
  />
);
export const DescriptorBad = props => (
  <DescriptorBadIcon
    {...props}
    tabIndex="-1"
  />
);
